<template>
  <elevator-properties :liftpropertytype="7"></elevator-properties>
</template>
<script>
import { getItemFromArrayByKey } from 'U'
import store from '@/store'
import elevatorProperties from 'V/jcgn/elevatorProperties/Index.vue'
export default {
  name: 'elevatorDraft',
  components: {
    elevatorProperties,
  },
  beforeRouteEnter(to, from, next) {
    let toTab = getItemFromArrayByKey(store.state.main.tabs, 'id', to.name);
    if(!toTab || from.name != 'elevatorArchivesDetail') {
      store.commit('delKeepAlive', to.name)
    }
    next()
  },
}
</script>